import { OrderStatus } from '@/core/entities/order-status';

/**
 * Obtiene el color de un estado de pedido.
 *
 * @param status - El estado del pedido.
 *
 * @returns El color del estado.
 */
export function getStatusColor(status: OrderStatus | undefined) {
  if (!status?.id) {
    return 'default';
  }

  switch (status.id) {
    case 'D1': // En proceso
      return 'info';
    case 'D2': // Parcialmente entregado
      return 'warning';
    case 'D3': // Entregado
      return 'success';
    case 'D4': // Devuelto
      return 'default';
    case 'D0': // Creado
      return 'default';
    case 'DELAYED': // Retrasado
      return 'error';
    default:
      console.warn(`Estado desconocido: ${status.id}`);
      return 'default';
  }
}
